import * as Background from './background_controller';
import logger from './controllers/logger';
import type { GameManager, PerformanceTier } from './types';

const ROLLING_WINDOW = 60;
const PAUSE_ID = -9001;

const dtWindow: number[] = [];
let badTimer = 0;
let goodTimer = 0;

export function update(manager: GameManager, dt: number): void {
  dtWindow.push(dt);
  if (dtWindow.length > ROLLING_WINDOW) dtWindow.shift();

  const avgDt = dtWindow.reduce((s, v) => s + v, 0) / dtWindow.length;
  const avgMs = avgDt * 1000;

  const { performanceTier } = manager;

  const degradeThreshold = performanceTier === 0 ? 50 : 80;
  const recoverThreshold = performanceTier === 1 ? 20 : 40;

  if (avgMs > degradeThreshold) {
    badTimer += dt;
    goodTimer = 0;
  } else if (avgMs < recoverThreshold) {
    goodTimer += dt;
    badTimer = 0;
  } else {
    badTimer = 0;
    goodTimer = 0;
  }

  let newTier = performanceTier;
  if (badTimer >= 2 && performanceTier < 2) {
    newTier = (performanceTier + 1) as PerformanceTier;
    badTimer = 0;
  } else if (goodTimer >= 10 && performanceTier > 0) {
    newTier = 0;
    goodTimer = 0;
  }

  if (newTier !== performanceTier) {
    manager.performanceTier = newTier;
    manager.performanceTierChanged = true;
    logger.debug({ tier: newTier, avgMs: Math.round(avgMs) }, 'performance: tier changed');
    applyTier(manager, newTier);
  }
}

function applyTier(manager: GameManager, tier: PerformanceTier): void {
  if (tier >= 1) {
    Background.objectRequestPauseBackground(PAUSE_ID);
  } else {
    Background.objectReleasePauseBackground(PAUSE_ID);
  }
}
